import type { ReactNode } from 'react';
import { WarehouseLocation } from 'src/api/warehouses.api';

/** `WarehouseLocation.tags` is a JSON scalar, so any JSON shape can arrive at runtime. */
type LocationTags = WarehouseLocation['tags'];

function toLocationTagNode(value: LocationTags | undefined): ReactNode {
  if (Array.isArray(value)) return value.map(toLocationTagNode);
  if (value !== null && typeof value === 'object') {
    throw new TypeError('Warehouse location tag objects cannot be rendered');
  }
  return value;
}

/** Reads one tag while preserving the grid's legacy React child semantics. */
export function readLocationTag(tags: LocationTags | undefined, tagKey: string): ReactNode {
  if (tags === null || tags === undefined || typeof tags !== 'object' || Array.isArray(tags)) return null;
  return toLocationTagNode(tags[tagKey]);
}

/** One tag as a cell value (text, or a list of texts); never throws on an object-shaped tag. */
export function readLocationTagValue(tags: LocationTags | undefined, tagKey: string): unknown {
  if (tags === null || tags === undefined || typeof tags !== 'object' || Array.isArray(tags)) return null;
  return tags[tagKey] ?? null;
}
